import { memo } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { Switch } from './index';
import { SwitchProps } from '@mui/material/Switch';

type SwitchHookFormProps = Omit<SwitchProps, 'checked'> & {
  name: string;
  control?: any;
  label?: string;
};

export const SwitchHookForm = memo<SwitchHookFormProps>(
  function SwitchHookForm({
    name,
    control: _control,
    ...switchProps
  }: SwitchHookFormProps) {
    let control = _control;

    if (!control) {
      const { control: contextControl } = useFormContext();
      control = contextControl;
    }

    const {
      field: { value, ref, onChange, ...fieldProps },
      fieldState,
    } = useController({
      name,
      control,
      defaultValue: switchProps?.defaultChecked || false,
    });

    return (
      <Switch
        color="primary"
        checked={!!value}
        onChange={(e, checked) => onChange(checked)}
        inputRef={ref}
        {...switchProps}
        {...fieldProps}
      />
    );
  }
);
